<app-spinner name="multi-org-ta"></app-spinner>

<!-- Display Required Label if showRequired is true -->
@if (showRequired()) {
  <div class="font-16 semibold mtb-10 flex justify-end">
    <font class="font-required">*(Required)</font>
  </div>
}

<!-- Informative Text based on Role Admin Status -->
<div class="mb-10 mt-20">
  @if (isRoleAdmin()) {
    <span>
      You are a role administrator for multiple organizations. Please select an organization to manage its roles.
    </span>
  }
  @if (!isRoleAdmin()) {
    <span>
      Please choose the role group for which you are requesting a role.
    </span>
  }
</div>

<!-- Role Selection and Organization Selection Section -->
<div class="border-bottom border-gray-600 mb-20 pb-10">
  <div class="inline-text-field-container even-cols flex-row gap-20" [ngStyle]="{ width: selectFieldsWidth() }">

    <!-- Role Selection Dropdown -->
    @if (showSelectRoles()) {
      <div class="select-container chevron border-bottom border-gray-600">
        <select class="ds-select-field rounded-4 hover-gray-300" [class.disabled]="!hasProfileAdmin && pageType != 'add-role'" required [(ngModel)]="selectedRoleGroup" name="selectRoles" (change)="onChangeRoles()">
          @for (role of roleGroups; track role) {
            <option [ngValue]="role" [selected]="role.roleAssignGroupKey == selectedRoleGroup?.roleAssignGroupKey">
              {{ role.roleAssignGroupName }}
            </option>
          }
        </select>
        <label class="ds-floating-label">*Select Role Groups</label>
      </div>
    }

    <!-- Organization Selection with ng-select -->
    @if (showOrg) {
      <ng-select
        [virtualScroll]="true"
        class="custom2"
        [disabled]="orgDisable"
        placeholder="*Select Organization"
        [items]="organizations"
        [clearable]="true"
        [searchable]="true"
        [searchFn]="customFilter"
        [(ngModel)]="selectedOrganization"
        [disabled]="pageType == 'remove-role'"
        (keyup)="onKeyUp($event)"
        (change)="onChangeOrg()">
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label">{{ (item?.irn || item?.orgIrn) + " - " + item?.orgName }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-value-label">{{ (item?.irn || item?.orgIrn) + " - " + item?.orgName }}</span>
        </ng-template>
      </ng-select>
    }
  </div>
</div>
